import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addFaq, fetchFaq, fetchFaqById, removeFaq, updateFaq } from "../../api/faqApi";


export const getFaqs = createAsyncThunk(
  "roomType/getFaqs",
        //  @ts-ignore 

  async ({page,limit}, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchFaq(page,limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getFaqById = createAsyncThunk(
    "Faq/getFaqById",
    async (id: string, {dispatch, rejectWithValue }) => {
      dispatch(resetStatus());

      try {
        return await fetchFaqById(id);
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

// Thunk for creating a new room type
export const createFaq = createAsyncThunk(
  "Faq/createFaq",
  async (newFaq: any, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addFaq(newFaq);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for editing a room type
export const editFaq = createAsyncThunk(
  "Faq/editFaq",
  async (
    { id, updatedFaq }: { id: string; updatedFaq: any },
    {dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateFaq(id, updatedFaq);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for deleting a room type
export const deleteFaq = createAsyncThunk(
  "Faq/deleteFaq",
  async (id: string, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeFaq(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Room Type Slice
const faqSlice = createSlice({
  name: "faq",
  initialState: {
    faqs: [] as any[],
    faq: null as any | null, 
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getRoomTypes

      .addCase(getFaqs.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.faqs = action.payload;
      })
      .addCase(getFaqs.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      .addCase(createFaq.fulfilled, (state, action: PayloadAction<any>) => {
        if(Array.isArray(action.payload)){
          state.faqs.push(action.payload);
          state.status = true;
          state.msg = "Faq created successfully.";
        }
        else{
          console.log('faq not aaray');

        }

    
      })
      .addCase(getFaqById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        console.log(action.payload,'action.payload');
        
        state.faq = action.payload;
      })

      .addCase(editFaq.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if(Array.isArray(state.faqs)){
          const index = state.faqs.findIndex((faq) => faq.id === id);
          if (index !== -1) {
            state.faqs[index] = data;
          }
          state.status = true;
          state.msg = "Room type updated successfully.";
        }else{
          console.log('faq not aaray');


        }
      
      })

      .addCase(deleteFaq.fulfilled, (state, action: PayloadAction<string>) => {

        if(Array.isArray(state.faqs)){
          state.faqs = state.faqs.filter((faq) => faq.id !== action.payload);
          state.status = true;
          state.msg = "Room type deleted successfully.";
        }else{
          console.log('faq not aaray');


        }
   
      });
  },
});

export const { resetStatus } = faqSlice.actions;
export default faqSlice.reducer;
